<div [class.center-div]="vCenter">
  <div class="center spinner {{sizeClass}}"></div>
  <div class="center" translate>
    <ng-content></ng-content>
  </div>
</div>
